/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { BulkDeleteRotorWingShiftsRequest } from '../../models/bulk-delete-rotor-wing-shifts-request';

export interface BulkDeleteRotorWingShifts$Params {
      body: BulkDeleteRotorWingShiftsRequest
}

export function bulkDeleteRotorWingShifts(http: HttpClient, rootUrl: string, params: BulkDeleteRotorWingShifts$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse>> {
  const rb = new RequestBuilder(rootUrl, bulkDeleteRotorWingShifts.PATH, 'delete');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse>;
    })
  );
}

bulkDeleteRotorWingShifts.PATH = '/api/scheduler/daily-line-schedule/rotor-wing/assignments';
